// Single source of truth for the Firebase web config, read from VITE_ env.
// Shared by the game (asset overrides + access gate) and the studio portal.

export type FirebaseConfig = {
  apiKey: string;
  authDomain?: string;
  projectId: string;
  storageBucket?: string;
  appId?: string;
};

// Returns the config, or null when the minimum keys are absent (not set up yet).
export function getFirebaseConfig(): FirebaseConfig | null {
  const env = import.meta.env;
  const apiKey = env.VITE_FIREBASE_API_KEY;
  const projectId = env.VITE_FIREBASE_PROJECT_ID;
  if (!apiKey || !projectId) return null;
  return {
    apiKey,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId,
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
    appId: env.VITE_FIREBASE_APP_ID,
  };
}

// True when dev + opted into local emulators. Game gate and studio both honor
// this so they share the same auth session in emulator mode.
export function useEmulators(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_FIREBASE_USE_EMULATORS === '1';
}
